// globaldatabase.js

import slimming from "../../assets/CoverImages/slimming.webp";
import slimming2 from "../../assets/CoverImages/slimming2.webp";
import hifu from "../../assets/CoverImages/hifu.webp";
import hifu2 from "../../assets/CoverImages/hifu2.webp";
import BeautyFacialsimage from "../../assets/CoverImages/BeautyFacials.webp";
import BeautyFacialsimage2 from "../../assets/CoverImages/BeautyFacials2.webp";
import AcneScarReductionimage from "../../assets/CoverImages/AcneScarReductionimage.webp";
import AcneScarReductionimage2 from "../../assets/CoverImages/AcneScarReductionimage2.webp";
import Pigmentationimage from "../../assets/CoverImages/Pigmentationimage.webp";
import Pigmentationimage2 from "../../assets/CoverImages/Pigmentationimage2.webp";

import antiacnaiimage from "../../assets/CoverImages/antiacnaiimage.webp";
import antiacnaiimage2 from "../../assets/CoverImages/antiacnaiimage2.webp";
import LaserHairRemovalimage from "../../assets/CoverImages/LaserHairRemovalimage.webp";
import LaserHairRemovalimage2 from "../../assets/CoverImages/LaserHairRemovalimage2.webp";

import HairCareimage from "../../assets/CoverImages/HairCareimage.webp";
import HairCareimage2 from "../../assets/CoverImages/HairCareimage2.webp";

import PRPHairTherapyimage from "../../assets/CoverImages/PRPHairTherapyimage.webp";
import PRPHairTherapyimage2 from "../../assets/CoverImages/PRPHairTherapyimage2.webp";

import HairTransplantimage from "../../assets/CoverImages/HairTransplantimage.webp";
import HairTransplantimage2 from "../../assets/CoverImages/HairTransplantimage2.webp";

import DentalWhiteningimage from "../../assets/CoverImages/DentalWhiteningimage.webp";
import DentalWhiteningimage2 from "../../assets/CoverImages/DentalWhiteningimage2.webp";

import DentalImplantsimage from "../../assets/CoverImages/DentalImplantsimage.webp";
import DentalImplantsimage2 from "../../assets/CoverImages/DentalImplantsimage2.webp";

import RoutineDentalCareimage from "../../assets/CoverImages/RoutineDentalCareimage.webp";
import RoutineDentalCareimage2 from "../../assets/CoverImages/RoutineDentalCareimage2.webp";

//services
export const ServicesPageDetails = {
  coverimage: slimming,
  title: "Services",
  subtitle:
    "Cyber Space Digital is your reliable partner for innovative, scalable, and high-performance web development solutions.",
  coverImage: {
    src: slimming, // Update this path to the actual image path
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Web Development That Drives Results.",
    heading: "Turn Your Vision Into a Powerful Web Experience.",
    description:
      "At Cyber Space Digital, we specialize in building robust, secure, and scalable web applications aligned with your business objectives. Whether you're a startup or an enterprise, we lay the digital foundation for your long-term success.",
  },
  services: [
    {
      icon: antiacnaiimage,
      title: "Web Development",
      description:
        "Build scalable, fast, and SEO-friendly websites and web apps that are tailored to your business needs. From static websites to complex web portals — we deliver performance-focused solutions.",
      link: "/services/web-development-company",
    },
    {
      icon: antiacnaiimage,
      title: "Mobile Application",
      description:
        "Create seamless mobile experiences with our custom Android and iOS app development services. We specialize in building native, hybrid, and cross-platform apps that keep your users engaged.",
      link: "/services/mobile-app-development-company",
    },
    {
      icon: antiacnaiimage,
      title: "Digital Marketing",
      description:
        "Boost your online presence with strategic SEO, PPC, social media marketing, and content campaigns. We drive traffic, build engagement, and increase conversions across digital channels.",
      link: "/services/digital-marketing-company",
    },
    {
      icon: antiacnaiimage,
      title: "Multimedia",
      description:
        "Engage your audience with stunning multimedia content — including videos, animations, explainer reels, and motion graphics that tell your brand story in a captivating way.",
      link: "/services/multimedia-company",
    },
    {
      icon: antiacnaiimage,
      title: "Branding",
      description:
        "Create a lasting impression with strategic branding. From logo design to brand identity systems, we craft cohesive visuals and messaging that connect with your audience.",
      link: "/services/branding-comapny",
    },
    {
      icon: antiacnaiimage,
      title: "Advertising",
      description:
        "Run targeted ad campaigns across platforms like Google, Facebook, and Instagram. We help you reach the right audience with creative, data-driven advertising strategies that convert.",
      link: "/services/advertising-company",
    },
  ],
};

//Slimming
export const SlimmingWeightManagement = {
  SeoName: {
    seotitle: "SlimmingWeightManagementSEO",
  },

  // Hero Section
  title: "Slimming & Weight Management",
  subtitle:
    "Transform your body, transform your life with our comprehensive weight loss solutions",

  // Introduction Section
  images: {
    intro: slimming,
    complementary: slimming2,
  },
  introduction: [
    "Embark on a transformative journey towards a healthier, more confident you with our scientifically-backed slimming and weight management programs. Our holistic approach combines advanced technology with personalized care to help you achieve sustainable weight loss and maintain your ideal body shape.",
    "Our certified nutritionists and fitness experts create customized plans that address your unique body type, metabolism, and lifestyle. From non-invasive fat reduction to metabolic optimization, we provide comprehensive solutions that deliver visible, long-lasting results without extreme diets or strenuous workouts.",
  ],

  // Stats Section
  stats: [
    { value: "5-10", label: "Kgs Weight Loss" },
    { value: "2-4", label: "Inches Reduction" },
    { value: "12", label: "Weeks Program" },
    { value: "95%", label: "Success Rate" },
  ],

  // Benefits Section
  benefits: [
    "Personalized Diet Plans",
    "Non-Invasive Procedures",
    "Metabolic Boost",
    "Stubborn Fat Reduction",
    "Body Contouring",
    "Improved Metabolism",
    "Lifestyle Coaching",
    "Sustainable Results",
    "No Side Effects",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Your Journey to a Healthier You",
  complementaryDescription: [
    "Our weight management program is designed to work synergistically with various wellness treatments, creating a comprehensive approach to health and beauty. Whether you're targeting specific problem areas or seeking overall body transformation, we provide tailored solutions that fit your unique needs.",
    "This integrated approach allows you to achieve multiple wellness goals simultaneously, from fat reduction and muscle toning to skin tightening and cellulite treatment. Our programs work seamlessly with Nutrition Counseling, Yoga Therapy, Detox Programs, and Fitness Training for complete transformation.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Stubborn Belly Fat",
    "Love Handles",
    "Thigh Fat",
    "Double Chin",
    "Arm Fat",
    "Slow Metabolism",
    "Cellulite",
    "Water Retention",
    "Yo-yo Dieting",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How much weight can I expect to lose?",
      answer:
        "Most clients lose 5-10 kgs in 12 weeks, depending on their starting weight, metabolism, and adherence to the program. Results vary individually but are sustainable and healthy.",
    },
    {
      question: "Are the treatments painful or invasive?",
      answer:
        "No, our treatments are completely non-invasive and pain-free. We use advanced technologies like radiofrequency, cavitation, and laser that are comfortable and require no downtime.",
    },
    {
      question: "Will I regain the weight after the program?",
      answer:
        "Our program includes lifestyle coaching and maintenance plans to ensure you maintain your results. We teach sustainable habits that help prevent weight regain.",
    },
    {
      question: "How long does each session take?",
      answer:
        "Sessions typically take 45-60 minutes, making it easy to incorporate into your busy schedule. Most programs require 2-3 sessions per week.",
    },
    {
      question: "Do I need to follow a strict diet?",
      answer:
        "We provide personalized diet plans that are practical and sustainable. Our focus is on balanced nutrition rather than extreme restrictions, making it easier to maintain long-term.",
    },
    {
      question: "Can I target specific body areas?",
      answer:
        "Yes, our treatments can specifically target problem areas like belly, thighs, arms, and double chin while also promoting overall weight loss.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Weight Management Program?",
    points: [
      "Medical Supervision",
      "Personalized Treatment Plans",
      "Non-Invasive Technology",
      "Sustainable Results",
      "Holistic Approach",
      "Certified Experts",
      "No Downtime",
      "Affordable Packages",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready to Start Your Transformation?",
    description:
      "Join thousands of successful clients who have achieved their dream bodies with our proven weight management programs. Take the first step towards a healthier, more confident you today.",
    primaryText: "Start Your Journey",
    primaryLink: "/contactus",
    secondaryText: "Free Body Analysis",
    secondaryLink: "/contactus",
  },
};

export const HIFUBody = {
  SeoName: {
    seotitle: "HIFUBodySEO",
  },

  // Hero Section
  title: "HIFU for Body",
  subtitle:
    "Non-surgical body contouring and skin tightening with advanced ultrasound technology",

  // Introduction Section
  images: {
    intro: hifu2,
    complementary: hifu,
  },
  introduction: [
    "Experience the revolutionary power of High-Intensity Focused Ultrasound (HIFU) for non-invasive body sculpting and skin tightening. This cutting-edge technology delivers focused ultrasound energy to target deep tissue layers, stimulating collagen production and triggering natural body contouring processes.",
    "HIFU safely and effectively addresses stubborn fat deposits and loose skin without surgery, downtime, or incisions. The precision-focused energy reaches depths up to 4.5mm, making it ideal for various body areas that require firming, lifting, and contouring.",
  ],

  // Stats Section
  stats: [
    { value: "60-90", label: "Minutes Session" },
    { value: "2-3", label: "Sessions Recommended" },
    { value: "3-6", label: "Months Results Last" },
    { value: "0", label: "Downtime" },
  ],

  // Benefits Section
  benefits: [
    "Non-Surgical Body Contouring",
    "Deep Skin Tightening",
    "Stimulates Collagen Production",
    "Targets Multiple Body Areas",
    "No Downtime Required",
    "Precise Fat Reduction",
    "Natural-Looking Results",
    "Long-Lasting Effects",
    "FDA-Approved Technology",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Sculpt Your Dream Body",
  complementaryDescription: [
    "HIFU for body works exceptionally well when combined with other body contouring treatments, creating comprehensive transformation programs. Whether you're targeting abdominal fat, thigh bulges, or arm sagging, HIFU provides the foundation for dramatic body reshaping.",
    "This advanced technology integrates seamlessly with treatments like Radio Frequency, Cavitation, Vacuum Therapy, and LPG Endermologie. The combination approach ensures optimal results for both fat reduction and skin tightening, giving you the toned, sculpted appearance you desire.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Sagging Abdominal Skin",
    "Bra Bulge & Back Fat",
    "Thigh & Buttock Sagging",
    "Upper Arm Laxity",
    "Love Handles",
    "Double Chin",
    "Post-Pregnancy Laxity",
    "Age-Related Skin Looseness",
    "Stubborn Fat Pockets",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How does HIFU work for body contouring?",
      answer:
        "HIFU uses focused ultrasound energy to heat deep tissue layers, causing thermal coagulation that stimulates collagen production and destroys fat cells. This results in natural skin tightening and gradual body contouring over several weeks.",
    },
    {
      question: "Is HIFU treatment painful?",
      answer:
        "Most patients experience mild discomfort or a warm sensation during treatment. We use advanced cooling technology and can adjust intensity levels to ensure your comfort throughout the procedure.",
    },
    {
      question: "When will I see results?",
      answer:
        "Initial results appear within 2-3 weeks, with optimal results visible after 2-3 months as collagen production continues. The body's natural healing process creates gradual but significant improvements.",
    },
    {
      question: "How many sessions are required?",
      answer:
        "Most clients achieve desired results with 1-3 sessions spaced 4-6 weeks apart. The number depends on your specific concerns, skin laxity, and desired level of improvement.",
    },
    {
      question: "Is there any downtime after HIFU?",
      answer:
        "No, HIFU requires zero downtime. You can resume normal activities immediately after treatment. Some clients experience mild redness or swelling that typically resolves within a few hours.",
    },
    {
      question: "Who is an ideal candidate for HIFU body treatment?",
      answer:
        "Ideal candidates are adults with mild to moderate skin laxity and stubborn fat deposits who prefer non-surgical solutions. We conduct a thorough assessment to determine if HIFU is right for you.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our HIFU Body Treatment?",
    points: [
      "Advanced HIFU Technology",
      "Certified Practitioners",
      "Customized Treatment Plans",
      "Non-Invasive & Safe",
      "Visible & Lasting Results",
      "Comfortable Procedure",
      "Multiple Body Areas",
      "Proven Success Rate",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready for Non-Surgical Body Transformation?",
    description:
      "Join countless satisfied clients who have achieved their body goals without surgery or downtime. Experience the power of advanced HIFU technology for natural-looking, lasting results.",
    primaryText: "Book Consultation",
    primaryLink: "/contactus",
    secondaryText: "View Before-After Results",
    secondaryLink: "/gallery/hifu-body",
  },
};

//SkinCare
export const BeautyFacials = {
  SeoName: {
    seotitle: "BeautyFacialsSEO",
  },

  // Hero Section
  title: "Beauty Facials",
  subtitle: "Professional facial treatments for radiant, glowing skin",

  // Introduction Section
  images: {
    intro: BeautyFacialsimage2,
    complementary: BeautyFacialsimage,
  },
  introduction: [
    "Indulge in our luxurious beauty facials designed to rejuvenate, hydrate, and transform your skin. Our expert aestheticians use premium products and advanced techniques to address your specific skin concerns while providing ultimate relaxation.",
    "From deep cleansing and exfoliation to intensive hydration and brightening, each facial is customized to your skin type and concerns. Experience immediate radiance and long-term skin health improvement with our comprehensive facial treatments.",
  ],

  // Stats Section
  stats: [
    { value: "60-90", label: "Minutes Session" },
    { value: "4-6", label: "Steps Process" },
    { value: "Instant", label: "Glow Visible" },
    { value: "100%", label: "Natural Ingredients" },
  ],

  // Benefits Section
  benefits: [
    "Deep Skin Cleansing",
    "Instant Radiance Boost",
    "Hydration & Nourishment",
    "Pore Minimization",
    "Even Skin Tone",
    "Stress Relief",
    "Anti-Aging Benefits",
    "Customized Solutions",
    "Professional Extraction",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Elevate Your Skincare Routine",
  complementaryDescription: [
    "Our beauty facials serve as the perfect foundation for comprehensive skincare, working harmoniously with other treatments to maximize results. Whether you're preparing for special events or maintaining regular skincare, facials enhance your skin's receptivity to other treatments.",
    "These treatments complement advanced procedures like Chemical Peels, Microdermabrasion, LED Therapy, and Radio Frequency. The combination approach ensures your skin remains healthy, balanced, and ready to absorb the benefits of other skincare treatments.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Dull & Tired Skin",
    "Clogged Pores",
    "Dehydrated Skin",
    "Uneven Skin Texture",
    "Blackheads & Whiteheads",
    "Lack of Radiance",
    "Stress & Fatigue Signs",
    "Environmental Damage",
    "Pre-Mature Aging",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How often should I get a facial?",
      answer:
        "For optimal results, we recommend facials every 4-6 weeks. This allows your skin to complete its natural renewal cycle while maintaining the benefits of professional treatment.",
    },
    {
      question: "Are facials suitable for sensitive skin?",
      answer:
        "Yes, we customize every facial based on your skin type and sensitivity. We use gentle, hypoallergenic products and adjust techniques to ensure comfort and effectiveness for sensitive skin.",
    },
    {
      question: "What's the difference between basic and luxury facials?",
      answer:
        "Luxury facials include additional steps like specialized masks, advanced massage techniques, shoulder/neck massage, and premium products that target specific concerns more intensively.",
    },
    {
      question: "Can I wear makeup after a facial?",
      answer:
        "We recommend avoiding makeup for at least 6-8 hours after your facial to allow your skin to breathe and fully absorb the treatment benefits. Your skin will be clean and glowing naturally.",
    },
    {
      question: "Do facials help with acne?",
      answer:
        "Yes, our deep cleansing facials include professional extraction and antibacterial treatments that help control acne, reduce inflammation, and prevent future breakouts.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Beauty Facials?",
    points: [
      "Certified Aestheticians",
      "Premium Skincare Products",
      "Customized Treatments",
      "Hygienic Environment",
      "Instant Visible Results",
      "Relaxing Experience",
      "Multiple Facial Types",
      "Affordable Packages",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready for Radiant, Glowing Skin?",
    description:
      "Experience the transformative power of professional facials. Book your session today and discover the immediate difference in your skin's health and appearance.",
    primaryText: "Book Facial Session",
    primaryLink: "/contactus",
    secondaryText: "Skin Analysis",
    secondaryLink: "/contactus",
  },
};

export const AcneScarReduction = {
  SeoName: {
    seotitle: "AcneScarReductionSEO",
  },

  // Hero Section
  title: "Acne Scar Reduction",
  subtitle: "Advanced treatments to smooth and rejuvenate scarred skin",

  // Introduction Section
  images: {
    intro: AcneScarReductionimage,
    complementary: AcneScarReductionimage2,
  },
  introduction: [
    "Say goodbye to acne scars with our advanced scar reduction treatments that restore your skin's smooth texture and even tone. We use cutting-edge technology to target different types of acne scars, from icepick and boxcar scars to rolling scars and hyperpigmentation.",
    "Our comprehensive approach combines multiple modalities to break down scar tissue, stimulate collagen production, and promote healthy skin regeneration. Whether your scars are recent or years old, we have solutions to significantly improve your skin's appearance.",
  ],

  // Stats Section
  stats: [
    { value: "70-90%", label: "Scar Improvement" },
    { value: "4-8", label: "Sessions Required" },
    { value: "3-6", label: "Months Treatment" },
    { value: "Long", label: "Lasting Results" },
  ],

  // Benefits Section
  benefits: [
    "Smooths Skin Texture",
    "Reduces Scar Depth",
    "Evens Skin Tone",
    "Stimulates Collagen",
    "Minimizes Pore Appearance",
    "Boosts Confidence",
    "Non-Invasive Options",
    "Customized Plans",
    "Professional Guidance",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Comprehensive Scar Management",
  complementaryDescription: [
    "Acne scar reduction works best when combined with complementary treatments that address pigmentation, texture, and overall skin health. Our multi-modal approach ensures comprehensive improvement for all types of acne scarring.",
    "We often combine treatments like Microdermabrasion, Chemical Peels, Dermaroller, Laser Therapy, and Subcision based on your specific scar type and skin condition. This integrated strategy delivers superior results compared to single-treatment approaches.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Icepick Scars",
    "Boxcar Scars",
    "Rolling Scars",
    "Post-Acne Pigmentation",
    "Uneven Skin Texture",
    "Enlarged Pores",
    "Scar Redness",
    "Atrophic Scars",
    "Hypertrophic Scars",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How long does it take to see results?",
      answer:
        "Initial improvements are visible after 2-3 sessions, with significant results appearing after 4-8 sessions. Complete treatment typically takes 3-6 months depending on scar severity.",
    },
    {
      question: "Are the treatments painful?",
      answer:
        "Most treatments involve minimal discomfort. We use topical anesthetics for more intensive procedures to ensure your comfort throughout the process.",
    },
    {
      question: "Can old acne scars be treated?",
      answer:
        "Yes, we can effectively treat acne scars regardless of how old they are. Older scars might require more sessions but still show significant improvement.",
    },
    {
      question: "What's the downtime for these treatments?",
      answer:
        "Downtime varies by treatment. Non-invasive options have minimal downtime, while more intensive procedures may require 2-7 days of social downtime.",
    },
    {
      question: "Will my scars completely disappear?",
      answer:
        "While complete elimination isn't always possible, most patients achieve 70-90% improvement in scar appearance, making them barely noticeable to the naked eye.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Acne Scar Treatment?",
    points: [
      "Advanced Technology",
      "Multiple Treatment Options",
      "Customized Scar Analysis",
      "Experienced Dermatologists",
      "Proven Results",
      "Comprehensive Approach",
      "Safe Procedures",
      "Affordable Packages",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready to Restore Your Smooth Skin?",
    description:
      "Take the first step towards scar-free skin. Our expert team will create a personalized treatment plan to address your specific acne scars and help you regain confidence.",
    primaryText: "Start Scar Treatment",
    primaryLink: "/contactus",
    secondaryText: "Free Scar Assessment",
    secondaryLink: "/contactus",
  },
};

export const PigmentationTanning = {
  SeoName: {
    seotitle: "PigmentationTanningSEO",
  },

  // Hero Section
  title: "Pigmentation & Tanning",
  subtitle: "Advanced solutions for even-toned, radiant skin",

  // Introduction Section
  images: {
    intro: Pigmentationimage,
    complementary: Pigmentationimage2,
  },
  introduction: [
    "Combat pigmentation, sun damage, and uneven skin tone with our advanced depigmentation treatments. We address various forms of hyperpigmentation including melasma, sun spots, age spots, and post-inflammatory hyperpigmentation using safe, effective technologies.",
    "Our comprehensive approach not only removes existing pigmentation but also prevents future recurrence through proper sun protection guidance and maintenance treatments. Achieve clear, even-toned skin that radiates health and vitality.",
  ],

  // Stats Section
  stats: [
    { value: "80-95%", label: "Pigmentation Reduction" },
    { value: "3-6", label: "Sessions Needed" },
    { value: "2-4", label: "Weeks Between Sessions" },
    { value: "Long", label: "Term Maintenance" },
  ],

  // Benefits Section
  benefits: [
    "Even Skin Tone",
    "Reduces Dark Spots",
    "Removes Sun Damage",
    "Brightens Complexion",
    "Minimizes Melasma",
    "Prevents Recurrence",
    "Safe for All Skin Types",
    "Non-Invasive Options",
    "Immediate Results",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Comprehensive Pigmentation Control",
  complementaryDescription: [
    "Effective pigmentation treatment requires a multi-faceted approach that addresses both existing spots and prevents new ones from forming. Our treatments work synergistically with other skin rejuvenation procedures for optimal results.",
    "We often combine treatments like Chemical Peels, Laser Toning, Microdermabrasion, and Topical Lightening agents based on your specific pigmentation type and skin sensitivity. This comprehensive strategy ensures faster, more effective, and longer-lasting results.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Sun Spots & Age Spots",
    "Melasma & Chloasma",
    "Post-Inflammatory Hyperpigmentation",
    "Uneven Skin Tone",
    "Freckles & Sun Damage",
    "Dark Patches",
    "Tanning Removal",
    "Pregnancy Mask",
    "Photoaging",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How many sessions are needed for complete removal?",
      answer:
        "Most patients need 3-6 sessions spaced 2-4 weeks apart for significant improvement. Stubborn pigmentation like melasma may require ongoing maintenance sessions.",
    },
    {
      question: "Is the treatment safe for Indian skin?",
      answer:
        "Yes, we use technologies specifically safe for Indian skin types that are prone to pigmentation. Our experts customize settings to prevent any adverse effects.",
    },
    {
      question: "Can pigmentation return after treatment?",
      answer:
        "With proper sun protection and maintenance, results can be long-lasting. We provide comprehensive aftercare guidance to minimize recurrence.",
    },
    {
      question: "What's the downtime for pigmentation treatments?",
      answer:
        "Most treatments have minimal downtime. You might experience temporary redness or darkening that fades within a few days to a week.",
    },
    {
      question: "Are the results permanent?",
      answer:
        "While we can remove existing pigmentation effectively, new pigmentation can form due to sun exposure. Regular maintenance and sun protection are key to long-term results.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Pigmentation Treatment?",
    points: [
      "Advanced Q-Switch Laser",
      "Skin Type Specific Approach",
      "Experienced Practitioners",
      "Multiple Treatment Options",
      "Safe & Effective",
      "Customized Plans",
      "Visible Results",
      "Maintenance Guidance",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready for Clear, Even-Toned Skin?",
    description:
      "Don't let pigmentation affect your confidence. Our expert treatments can restore your natural skin tone and give you the radiant complexion you deserve.",
    primaryText: "Start Treatment",
    primaryLink: "/contactus",
    secondaryText: "Skin Analysis",
    secondaryLink: "/contactus",
  },
};
export const AntiAgingTreatments = {
  SeoName: {
    seotitle: "AntiAgingTreatmentsSEO",
  },

  // Hero Section
  title: "Anti-Aging Treatments",
  subtitle: "Turn back the clock with advanced age-defying solutions",

  // Introduction Section
  images: {
    intro: antiacnaiimage,
    complementary: antiacnaiimage2,
  },
  introduction: [
    "Rediscover your youthful radiance with our comprehensive anti-aging treatments designed to combat visible signs of aging. From fine lines and wrinkles to sagging skin and volume loss, we offer scientifically-proven solutions that deliver natural-looking, rejuvenated results.",
    "Our approach combines advanced technologies with proven techniques to address aging concerns at their root cause. Whether you're looking for preventive care or corrective treatments, we have options for every age and concern.",
  ],

  // Stats Section
  stats: [
    { value: "5-15", label: "Years Younger Look" },
    { value: "1-3", label: "Sessions Required" },
    { value: "12-24", label: "Months Results Last" },
    { value: "0", label: "Surgery Required" },
  ],

  // Benefits Section
  benefits: [
    "Reduces Wrinkles",
    "Lifts Sagging Skin",
    "Restores Volume",
    "Improves Skin Elasticity",
    "Brightens Complexion",
    "Minimizes Pores",
    "Non-Surgical Options",
    "Natural Looking Results",
    "Boosts Confidence",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Comprehensive Age Management",
  complementaryDescription: [
    "Effective anti-aging requires addressing multiple concerns simultaneously. Our treatments work together to provide comprehensive rejuvenation that addresses wrinkles, volume loss, skin quality, and overall facial harmony.",
    "We create customized combinations of treatments like Dermal Fillers, Botox, Thread Lifts, Laser Resurfacing, and Radio Frequency based on your specific aging concerns and desired outcomes. This holistic approach ensures natural, balanced, and long-lasting results.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Forehead Wrinkles",
    "Crow's Feet",
    "Marionette Lines",
    "Nasolabial Folds",
    "Sagging Jowls",
    "Volume Loss",
    "Neck Wrinkles",
    "Dull Complexion",
    "Age Spots",
  ],

  // FAQ Section
  faqs: [
    {
      question: "At what age should I start anti-aging treatments?",
      answer:
        "Preventive treatments can start in late 20s to early 30s, while corrective treatments are ideal for 35+. We recommend starting when you first notice signs of aging for best long-term results.",
    },
    {
      question: "Are the results natural-looking?",
      answer:
        "Yes, our expert practitioners focus on enhancing your natural features rather than changing your appearance. The goal is to make you look refreshed and rejuvenated, not 'done'.",
    },
    {
      question: "How long do anti-aging treatments last?",
      answer:
        "Results vary by treatment: Botox lasts 3-6 months, fillers 12-24 months, and energy-based treatments 1-2 years. Maintenance sessions help sustain results.",
    },
    {
      question: "Is there any downtime?",
      answer:
        "Most treatments have minimal to no downtime. You might experience slight redness or swelling that resolves within hours to a couple of days.",
    },
    {
      question: "Can men benefit from anti-aging treatments?",
      answer:
        "Absolutely! Anti-aging treatments are equally effective for men and are becoming increasingly popular. We customize approaches based on male anatomy and aging patterns.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Anti-Aging Treatments?",
    points: [
      "Expert Practitioners",
      "Advanced Technology",
      "Natural Looking Results",
      "Customized Plans",
      "Multiple Treatment Options",
      "Proven Safety Record",
      "Comprehensive Approach",
      "Ongoing Support",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready to Rediscover Your Youthful Glow?",
    description:
      "Take control of your aging process with our advanced treatments. Whether you're preventing first signs or reversing existing concerns, we have solutions for every stage.",
    primaryText: "Book Consultation",
    primaryLink: "/contactus",
    secondaryText: "Virtual Aging Analysis",
    secondaryLink: "/contactus",
  },
};

export const LaserHairRemoval = {
  SeoName: {
    seotitle: "LaserHairRemovalSEO",
  },

  // Hero Section
  title: "Laser Hair Removal",
  subtitle: "Permanent hair reduction for smooth, care-free skin",

  // Introduction Section
  images: {
    intro: LaserHairRemovalimage,
    complementary: LaserHairRemovalimage2,
  },
  introduction: [
    "Experience the freedom of smooth, hair-free skin with our advanced laser hair removal treatments. Using state-of-the-art technology, we safely and effectively target unwanted hair on all body areas, providing long-lasting results without the hassle of regular shaving or waxing.",
    "Our FDA-approved lasers precisely target hair follicles while leaving surrounding skin untouched, making the treatment safe for various skin types. With our comprehensive approach, you can achieve up to 90% permanent hair reduction in just a few sessions.",
  ],

  // Stats Section
  stats: [
    { value: "80-90%", label: "Hair Reduction" },
    { value: "6-8", label: "Sessions Required" },
    { value: "4-6", label: "Weeks Between Sessions" },
    { value: "Permanent", label: "Long-Term Results" },
  ],

  // Benefits Section
  benefits: [
    "Permanent Hair Reduction",
    "Smooth Skin Texture",
    "No More Ingrown Hairs",
    "Time & Cost Saving",
    "Precise Targeting",
    "All Body Areas",
    "Safe for Most Skin Types",
    "Minimal Discomfort",
    "Quick Sessions",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Complete Hair Management Solution",
  complementaryDescription: [
    "Laser hair removal works exceptionally well when combined with proper skincare and maintenance routines. Our comprehensive approach ensures not only effective hair reduction but also improved skin health and texture in treated areas.",
    "We often recommend complementary treatments like Photo Facials, Skin Brightening, and Hydrating Facials to enhance results and address any skin concerns in hair removal areas. This integrated approach ensures you achieve both hair-free and beautifully smooth skin.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Facial Hair",
    "Underarm Hair",
    "Bikini Line Hair",
    "Leg & Arm Hair",
    "Back & Chest Hair",
    "Ingrown Hairs",
    "Razor Bumps",
    "Dark Coarse Hair",
    "Frequent Shaving/Waxing",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How many sessions are needed?",
      answer:
        "Most people need 6-8 sessions spaced 4-6 weeks apart for optimal results. Hair growth cycles vary, and multiple sessions ensure all hairs are treated during their active growth phase.",
    },
    {
      question: "Is laser hair removal painful?",
      answer:
        "Most clients describe the sensation as a quick rubber band snap. We use advanced cooling technology to minimize discomfort, making the process quite tolerable.",
    },
    {
      question: "Can it work on dark skin?",
      answer:
        "Yes, we use ND:YAG laser technology that is safe and effective for darker skin tones. Our experts customize settings based on your skin type and hair color.",
    },
    {
      question: "What's the cost compared to waxing long-term?",
      answer:
        "While initial cost is higher, laser is more cost-effective long-term as it provides permanent reduction, eliminating ongoing waxing or shaving expenses.",
    },
    {
      question: "Are the results really permanent?",
      answer:
        "Laser provides permanent reduction of treated hairs. Some fine, light hairs may remain or regrow over years, but maintenance sessions can address these.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Laser Hair Removal?",
    points: [
      "Advanced ND:YAG Laser",
      "All Skin Types Safe",
      "Experienced Technicians",
      "Customized Treatment Plans",
      "Hygienic Environment",
      "Affordable Packages",
      "Quick Sessions",
      "Proven Results",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready for Smooth, Hair-Free Skin?",
    description:
      "Say goodbye to daily shaving and painful waxing. Our laser hair removal treatments offer a permanent solution for unwanted hair, giving you the confidence of smooth skin every day.",
    primaryText: "Start Laser Sessions",
    primaryLink: "/contactus",
    secondaryText: "Free Patch Test",
    secondaryLink: "/contactus",
  },
};

//HairCare
export const HairCareRestoration = {
  SeoName: {
    seotitle: "HairCareRestorationSEO",
  },

  // Hero Section
  title: "Hair Care & Restoration",
  subtitle: "Comprehensive solutions for healthy, strong, and beautiful hair",

  // Introduction Section
  images: {
    intro: HairCareimage,
    complementary: HairCareimage2,
  },
  introduction: [
    "Rediscover the joy of healthy, voluminous hair with our advanced hair care and restoration treatments. We address various hair concerns including hair fall, thinning, breakage, and scalp issues using scientifically-proven methods and premium products.",
    "Our holistic approach combines advanced therapies with personalized care to strengthen hair follicles, improve scalp health, and promote natural hair growth. Whether you're dealing with genetic hair loss or environmental damage, we have solutions for all hair types and concerns.",
  ],

  // Stats Section
  stats: [
    { value: "80-90%", label: "Reduced Hair Fall" },
    { value: "3-6", label: "Months Treatment" },
    { value: "40-60%", label: "Increased Volume" },
    { value: "0", label: "Side Effects" },
  ],

  // Benefits Section
  benefits: [
    "Reduces Hair Fall",
    "Stimulates New Growth",
    "Improves Hair Thickness",
    "Strengthens Hair Roots",
    "Nourishes Scalp",
    "Adds Natural Shine",
    "Prevents Breakage",
    "Customized Solutions",
    "Long-Lasting Results",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Complete Hair Health Solution",
  complementaryDescription: [
    "Hair restoration works best when combined with complementary treatments that address underlying scalp issues and overall hair health. Our integrated approach ensures comprehensive improvement from roots to tips.",
    "We often combine treatments like Scalp Mesotherapy, Laser Therapy, Nutritional Counseling, and Advanced Hair Serums based on your specific hair condition and goals. This multi-pronged strategy delivers faster and more effective results compared to single treatments.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Excessive Hair Fall",
    "Thinning Hair",
    "Bald Patches",
    "Receding Hairline",
    "Scalp Dandruff",
    "Dry & Brittle Hair",
    "Slow Hair Growth",
    "Split Ends",
    "Scalp Infections",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How long does it take to see results?",
      answer:
        "Initial reduction in hair fall is visible within 4-6 weeks, while significant new growth appears after 3-6 months of consistent treatment, depending on your hair condition.",
    },
    {
      question: "Are the treatments painful?",
      answer:
        "Most hair restoration treatments are completely painless. Some advanced therapies might involve minimal discomfort, but we ensure your comfort throughout the process.",
    },
    {
      question: "Can hair restoration work for genetic baldness?",
      answer:
        "Yes, we can significantly slow down genetic hair loss and stimulate new growth in early stages. Advanced cases might require combination with other treatments like PRP or hair transplant.",
    },
    {
      question: "How many sessions are required?",
      answer:
        "Most programs require 8-12 sessions over 3-6 months, followed by maintenance sessions. The exact number depends on your hair condition and desired results.",
    },
    {
      question: "Is there any downtime?",
      answer:
        "No, hair restoration treatments have zero downtime. You can resume your normal activities immediately after the session.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Hair Restoration?",
    points: [
      "Expert Trichologists",
      "Advanced Technology",
      "Personalized Treatment Plans",
      "Proven Results",
      "Natural Ingredients",
      "Comprehensive Approach",
      "Safe Procedures",
      "Affordable Packages",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready to Restore Your Hair's Health?",
    description:
      "Take the first step towards thicker, stronger, and more beautiful hair. Our expert team will create a personalized restoration plan tailored to your specific needs.",
    primaryText: "Start Hair Restoration",
    primaryLink: "/contactus",
    secondaryText: "Free Hair Analysis",
    secondaryLink: "/contactus",
  },
};

export const PRPHairTherapy = {
  SeoName: {
    seotitle: "PRPHairTherapySEO",
  },

  // Hero Section
  title: "PRP Hair Therapy",
  subtitle: "Natural hair regrowth using your body's own healing power",

  // Introduction Section
  images: {
    intro: PRPHairTherapyimage,
    complementary: PRPHairTherapyimage2,
  },
  introduction: [
    "Experience the revolutionary power of Platelet-Rich Plasma (PRP) therapy for natural hair regrowth and restoration. This advanced treatment uses your own blood's growth factors to stimulate dormant hair follicles and promote new hair growth.",
    "PRP is a completely natural, non-surgical solution that harnesses your body's healing mechanisms. The concentrated platelets in PRP release growth factors that increase blood supply to hair follicles and trigger the development of new follicles.",
  ],

  // Stats Section
  stats: [
    { value: "70-80%", label: "Success Rate" },
    { value: "4-6", label: "Sessions Recommended" },
    { value: "3-4", label: "Weeks Between Sessions" },
    { value: "Natural", label: "Treatment Process" },
  ],

  // Benefits Section
  benefits: [
    "Natural Hair Regrowth",
    "Non-Surgical Procedure",
    "Uses Own Blood",
    "Minimal Discomfort",
    "No Allergic Reactions",
    "Improves Hair Thickness",
    "Safe & Effective",
    "Quick Procedure",
    "Long-Lasting Results",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Advanced Hair Regrowth Solution",
  complementaryDescription: [
    "PRP therapy works exceptionally well when combined with other hair restoration treatments, creating a powerful synergy for optimal results. The growth factors from PRP enhance the effectiveness of other treatments.",
    "We often recommend combining PRP with treatments like Hair Mesotherapy, Low-Level Laser Therapy, and Nutritional Supplements. This comprehensive approach addresses hair loss from multiple angles for superior and faster results.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Androgenetic Alopecia",
    "Pattern Baldness",
    "Thinning Crown",
    "Receding Hairline",
    "Postpartum Hair Loss",
    "Stress-Related Hair Fall",
    "Chemotherapy Recovery",
    "Age-Related Thinning",
    "Weak Hair Follicles",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How does PRP work for hair growth?",
      answer:
        "PRP uses concentrated platelets from your blood that release growth factors. These factors stimulate hair follicles, increase blood supply, and promote the growth phase of hair cycles.",
    },
    {
      question: "Is PRP treatment painful?",
      answer:
        "We use topical anesthesia to ensure comfort. Most patients experience only mild discomfort during the injection process, which lasts only a few minutes.",
    },
    {
      question: "How soon will I see results?",
      answer:
        "Initial results appear after 3-4 months, with optimal results visible after 6-8 months as new hair grows and existing hair becomes thicker and stronger.",
    },
    {
      question: "How long do PRP results last?",
      answer:
        "Results can last 1-2 years. We recommend maintenance sessions every 6-12 months to sustain the results, depending on your hair loss condition.",
    },
    {
      question: "Who is an ideal candidate for PRP?",
      answer:
        "Ideal candidates are those with early to moderate hair loss, good overall health, and realistic expectations. We conduct a thorough assessment to determine suitability.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our PRP Therapy?",
    points: [
      "Medical Grade Equipment",
      "Experienced Doctors",
      "Sterile Procedure",
      "Customized PRP Concentration",
      "Proven Protocol",
      "Comfortable Experience",
      "Visible Results",
      "Natural Approach",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready for Natural Hair Regrowth?",
    description:
      "Harness your body's natural healing power to restore your hair. Our PRP therapy offers a safe, effective solution for hair loss without surgery or chemicals.",
    primaryText: "Book PRP Session",
    primaryLink: "/contactus",
    secondaryText: "Free Consultation",
    secondaryLink: "/contactus",
  },
};

export const HairTransplant = {
  SeoName: {
    seotitle: "HairTransplantSEO",
  },

  // Hero Section
  title: "Hair Transplant",
  subtitle: "Permanent solution for hair loss with natural-looking results",

  // Introduction Section
  images: {
    intro: HairTransplantimage,
    complementary: HairTransplantimage2,
  },
  introduction: [
    "Regain your confidence with our advanced hair transplant procedures that provide permanent, natural-looking results. Using state-of-the-art FUE (Follicular Unit Extraction) technique, we transplant healthy hair follicles from donor areas to restore hair in balding or thinning regions.",
    "Our expert surgeons ensure minimal discomfort, quick recovery, and results that blend seamlessly with your natural hair. Each procedure is customized to match your hairline, hair characteristics, and aesthetic goals for the most natural appearance.",
  ],

  // Stats Section
  stats: [
    { value: "95%", label: "Graft Survival Rate" },
    { value: "6-12", label: "Months Full Results" },
    { value: "Permanent", label: "Lifelong Results" },
    { value: "1", label: "Day Procedure" },
  ],

  // Benefits Section
  benefits: [
    "Permanent Solution",
    "Natural Hairline Design",
    "Minimal Scarring",
    "Quick Recovery",
    "Local Anesthesia",
    "Customized Density",
    "No Visible Signs",
    "Boosts Confidence",
    "Lifelong Results",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Complete Hair Restoration Journey",
  complementaryDescription: [
    "Hair transplant is often complemented with other treatments to ensure optimal results and maintain the health of existing hair. Our comprehensive approach addresses both transplanted and natural hair for complete satisfaction.",
    "We recommend combining hair transplant with PRP therapy to enhance graft survival and speed up healing. Post-transplant care includes medications, laser therapy, and nutritional guidance to maintain results and prevent further hair loss.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Male Pattern Baldness",
    "Receding Hairline",
    "Bald Patches",
    "Thinning Crown",
    "Female Pattern Hair Loss",
    "Scar Camouflage",
    "Eyebrow Restoration",
    "Beard Transplantation",
    "Temple Points Restoration",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How long does the procedure take?",
      answer:
        "Depending on the number of grafts, the procedure typically takes 6-8 hours. We work meticulously to ensure each graft is placed perfectly for natural results.",
    },
    {
      question: "Is hair transplant painful?",
      answer:
        "The procedure is performed under local anesthesia, so you won't feel pain during the surgery. Some discomfort during anesthesia injection is normal, which we manage effectively.",
    },
    {
      question: "When will I see final results?",
      answer:
        "Transplanted hair sheds in 2-3 weeks, then new growth starts in 3-4 months. Significant results are visible at 6 months, with full results at 12 months.",
    },
    {
      question: "What is the recovery time?",
      answer:
        "Most patients return to work in 3-5 days. Strenuous activities should be avoided for 2 weeks. The tiny crusts heal within 7-10 days.",
    },
    {
      question: "Are the results natural-looking?",
      answer:
        "Yes, our surgeons design hairlines that match your facial features and age. We place grafts at correct angles and densities to mimic natural hair growth patterns.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Hair Transplant?",
    points: [
      "Expert Hair Surgeons",
      "Advanced FUE Technology",
      "Natural Hairline Design",
      "High Graft Survival",
      "Sterile Operation Theatre",
      "Comprehensive Care",
      "Proven Results",
      "Lifelong Support",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready for Permanent Hair Restoration?",
    description:
      "Take the definitive step towards regaining your hair and confidence. Our hair transplant procedures offer permanent, natural-looking solutions for hair loss.",
    primaryText: "Free Transplant Consultation",
    primaryLink: "/contactus",
    secondaryText: "View Before-After Results",
    secondaryLink: "/gallery/hair-transplant",
  },
};

//DentalCare
export const DentalWhitening = {
  SeoName: {
    seotitle: "DentalWhiteningSEO",
  },

  // Hero Section
  title: "Dental Whitening",
  subtitle: "Professional teeth whitening for a brighter, more confident smile",

  // Introduction Section
  images: {
    intro: DentalWhiteningimage,
    complementary: DentalWhiteningimage2,
  },
  introduction: [
    "Transform your smile with our professional dental whitening treatments that safely and effectively remove stains and discoloration. Our advanced whitening systems can lighten your teeth by several shades in just one session, giving you the radiant smile you've always wanted.",
    "Using clinically proven whitening agents and advanced technology, we ensure maximum results with minimal sensitivity. Whether you have stains from coffee, tea, smoking, or natural aging, we have solutions to restore your teeth's natural whiteness.",
  ],

  // Stats Section
  stats: [
    { value: "5-8", label: "Shades Whiter" },
    { value: "60", label: "Minutes Session" },
    { value: "Instant", label: "Visible Results" },
    { value: "0", label: "Damage to Enamel" },
  ],

  // Benefits Section
  benefits: [
    "Instant Results",
    "Safe for Enamel",
    "Minimal Sensitivity",
    "Long-Lasting Whiteness",
    "Boosts Confidence",
    "Professional Strength",
    "Customized Treatment",
    "Quick Procedure",
    "Affordable Options",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Complete Smile Makeover",
  complementaryDescription: [
    "Teeth whitening is often the first step in comprehensive smile enhancement. When combined with other dental treatments, it can dramatically transform your overall appearance and dental health.",
    "We often recommend combining whitening with treatments like Dental Cleaning, Enamel Strengthening, and Cosmetic Consultations. This ensures not only whiter teeth but also improved oral health and overall smile aesthetics.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Coffee & Tea Stains",
    "Tobacco Stains",
    "Age-Related Yellowing",
    "Medication Stains",
    "Fluorosis Stains",
    "Genetic Discoloration",
    "Tetracycline Stains",
    "Wine Stains",
    "General Tooth Discoloration",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How long does teeth whitening last?",
      answer:
        "Professional whitening results typically last 1-2 years with proper care. Avoiding staining foods and beverages, along with good oral hygiene, helps maintain results longer.",
    },
    {
      question: "Is teeth whitening safe?",
      answer:
        "Yes, when performed by dental professionals, teeth whitening is completely safe. We use controlled concentrations and protect your gums to prevent any damage.",
    },
    {
      question: "Will whitening cause sensitivity?",
      answer:
        "Some patients experience temporary sensitivity, which usually subsides within 24-48 hours. We use desensitizing agents to minimize this effect.",
    },
    {
      question: "How white can my teeth get?",
      answer:
        "Most patients achieve 5-8 shades lighter. The final result depends on your natural tooth color and the cause of discoloration. We provide realistic expectations during consultation.",
    },
    {
      question: "Can anyone get teeth whitening?",
      answer:
        "Most adults are good candidates. However, we don't recommend whitening for pregnant women, children under 16, or people with certain dental conditions without prior consultation.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Dental Whitening?",
    points: [
      "Dental Professional Supervised",
      "Advanced Whitening Technology",
      "Safe & Effective",
      "Customized Treatment",
      "Minimal Sensitivity",
      "Quick Results",
      "Affordable Pricing",
      "Comprehensive Care",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready for a Dazzling White Smile?",
    description:
      "Transform your smile and boost your confidence with our professional teeth whitening treatments. Achieve noticeable results in just one session.",
    primaryText: "Book Whitening Session",
    primaryLink: "/contactus",
    secondaryText: "Free Smile Assessment",
    secondaryLink: "/contactus",
  },
};

export const DentalImplants = {
  SeoName: {
    seotitle: "DentalImplantsSEO",
  },

  // Hero Section
  title: "Dental Implants",
  subtitle: "Permanent solution for missing teeth that look and feel natural",

  // Introduction Section
  images: {
    intro: DentalImplantsimage,
    complementary: DentalImplantsimage2,
  },
  introduction: [
    "Restore your smile and chewing function with our advanced dental implant solutions. Dental implants are the gold standard for replacing missing teeth, providing a permanent, stable, and natural-looking alternative to dentures or bridges.",
    "Our experienced implantologists use state-of-the-art technology and premium materials to ensure successful integration and long-lasting results. Each implant is custom-designed to match your natural teeth in shape, color, and function.",
  ],

  // Stats Section
  stats: [
    { value: "98%", label: "Success Rate" },
    { value: "Lifetime", label: "Durability" },
    { value: "3-6", label: "Months Completion" },
    { value: "Natural", label: "Look & Feel" },
  ],

  // Benefits Section
  benefits: [
    "Permanent Solution",
    "Natural Appearance",
    "Restores Chewing Function",
    "Prevents Bone Loss",
    "No Adjacent Tooth Damage",
    "Easy Maintenance",
    "Comfortable Fit",
    "Boosts Confidence",
    "Long-Term Investment",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Complete Oral Rehabilitation",
  complementaryDescription: [
    "Dental implants are often part of a comprehensive oral rehabilitation plan. When combined with other dental treatments, they can restore not just missing teeth but overall oral health and function.",
    "We often combine implants with treatments like Bone Grafting, Sinus Lifts, Gum Treatments, and Full Mouth Rehabilitation. This ensures optimal conditions for implant success and overall dental health restoration.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Single Missing Tooth",
    "Multiple Missing Teeth",
    "Complete Tooth Loss",
    "Loose Dentures",
    "Difficulty Chewing",
    "Facial Collapse",
    "Bone Loss",
    "Failed Bridges",
    "Tooth Extraction Sites",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How long do dental implants last?",
      answer:
        "With proper care and maintenance, dental implants can last a lifetime. The crown may need replacement after 15-20 years due to normal wear and tear.",
    },
    {
      question: "Is the implant procedure painful?",
      answer:
        "The procedure is performed under local anesthesia, so you won't feel pain during surgery. Post-operative discomfort is manageable with medications and typically lasts only a few days.",
    },
    {
      question: "Who is a good candidate for implants?",
      answer:
        "Most adults in good general health with adequate bone density are good candidates. We conduct thorough examinations including 3D scans to determine suitability.",
    },
    {
      question: "What is the success rate of dental implants?",
      answer:
        "Dental implants have a success rate of 95-98% when placed by experienced professionals and with proper aftercare. We follow strict protocols to ensure optimal success.",
    },
    {
      question: "How long does the entire process take?",
      answer:
        "The complete process typically takes 3-6 months, including healing time between stages. Immediate load implants may offer faster results in suitable cases.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Dental Implants?",
    points: [
      "Experienced Implantologists",
      "3D Planning Technology",
      "Premium Implant Systems",
      "Sterile Surgical Protocol",
      "Comprehensive Aftercare",
      "High Success Rate",
      "Natural Aesthetics",
      "Lifetime Support",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready to Restore Your Complete Smile?",
    description:
      "Regain the function and confidence of natural teeth with our advanced dental implant solutions. Schedule your consultation to explore permanent tooth replacement options.",
    primaryText: "Free Implant Consultation",
    primaryLink: "/contactus",
    secondaryText: "View Before-After Cases",
    secondaryLink: "/gallery/dental-implants",
  },
};

export const RoutineDentalCare = {
  SeoName: {
    seotitle: "RoutineDentalCareSEO",
  },

  // Hero Section
  title: "Routine Dental Care",
  subtitle: "Comprehensive preventive care for lifelong oral health",

  // Introduction Section
  images: {
    intro: RoutineDentalCareimage,
    complementary: RoutineDentalCareimage2,
  },
  introduction: [
    "Maintain optimal oral health with our comprehensive routine dental care services. Regular dental check-ups and cleanings are essential for preventing dental problems, detecting issues early, and ensuring your smile stays healthy and beautiful for years to come.",
    "Our preventive care approach focuses on education, early intervention, and personalized maintenance plans. We believe that prevention is better than cure, and our routine care services are designed to keep your teeth and gums in excellent condition throughout your life.",
  ],

  // Stats Section
  stats: [
    { value: "Every 6", label: "Months Check-up" },
    { value: "90%", label: "Problems Prevented" },
    { value: "Early", label: "Issue Detection" },
    { value: "Lifelong", label: "Oral Health" },
  ],

  // Benefits Section
  benefits: [
    "Prevents Cavities",
    "Early Problem Detection",
    "Fresh Breath",
    "Gum Disease Prevention",
    "Stain Removal",
    "Oral Cancer Screening",
    "Personalized Advice",
    "Cost-Effective",
    "Peace of Mind",
  ],

  // Complementary Treatments Section
  complementaryTitle: "Complete Oral Health Management",
  complementaryDescription: [
    "Routine dental care forms the foundation of comprehensive oral health management. When combined with other preventive measures, it ensures long-term dental wellness and minimizes the need for complex treatments.",
    "Our routine care integrates seamlessly with services like Oral Hygiene Education, Dietary Counseling, Fluoride Treatments, and Sealant Applications. This holistic approach addresses all aspects of oral health maintenance and prevention.",
  ],
  bookingLink: "/contactus",

  // Concerns Section
  concerns: [
    "Plaque & Tartar Buildup",
    "Bad Breath",
    "Tooth Decay",
    "Gum Inflammation",
    "Stained Teeth",
    "Sensitive Teeth",
    "Oral Hygiene Maintenance",
    "Preventive Care",
    "Regular Check-ups",
  ],

  // FAQ Section
  faqs: [
    {
      question: "How often should I visit the dentist?",
      answer:
        "We recommend dental check-ups every 6 months for most patients. Those with specific dental conditions may need more frequent visits as advised by our dentists.",
    },
    {
      question: "What does a routine dental check-up include?",
      answer:
        "A comprehensive check-up includes examination of teeth and gums, oral cancer screening, professional cleaning, X-rays if needed, and personalized oral hygiene instructions.",
    },
    {
      question: "Is professional cleaning necessary if I brush regularly?",
      answer:
        "Yes, professional cleaning removes tartar that brushing alone cannot eliminate. It also helps prevent gum disease and maintains optimal oral health.",
    },
    {
      question: "At what age should children start dental visits?",
      answer:
        "Children should have their first dental visit by their first birthday or within 6 months of their first tooth appearing. Early visits establish good dental habits.",
    },
    {
      question: "Can routine care prevent major dental problems?",
      answer:
        "Absolutely! Regular check-ups can detect issues like cavities, gum disease, and oral cancer in early stages when they are easier and less expensive to treat.",
    },
  ],

  // Why Choose Us Section
  whyChooseUs: {
    title: "Why Choose Our Routine Dental Care?",
    points: [
      "Experienced Dentists",
      "Comprehensive Examinations",
      "Gentle Cleaning",
      "Personalized Care Plans",
      "Modern Equipment",
      "Preventive Focus",
      "Family-Friendly",
      "Affordable Maintenance",
    ],
  },

  // CTA Section
  cta: {
    title: "Ready for Optimal Oral Health?",
    description:
      "Take the proactive step towards lifelong dental wellness. Our routine care services ensure your smile stays healthy, beautiful, and problem-free.",
    primaryText: "Schedule Check-up",
    primaryLink: "/contactus",
    secondaryText: "Family Dental Plans",
    secondaryLink: "/contactus",
  },
};
